import {Component} from "preact";
import Admin from "../../../../services/admin";
import Session from "../../utils/session";
import {ActionButton, Cell, HCell, HRow, Row, Table} from "../../utils/table-utils";
import { Trans } from "@lingui/react/macro";
import MoneyFormatter from "../../utils/money-formatter";
import {openTopupPopup, TopupPopup} from "./manager-topup-popup";
import {ManagerTransactionPopup} from "./manager-transaction-history";
import {UserTransactionPopup} from "./menu-dashboard";
import Config from "../../config";

const COLORS = ['#616161', '#D32F2F', '#0288D1', '#689F38', '#512DA8', '#00796B', '#FBC02D', '#E64A19'];

export default class ManagerStructurelist extends Component {
    render() {
        return <div class="text-xs p-2 py-1">
            <UserRowSubTable filterid={Session.fetch('id')} />
        </div>;
    }
}

export class UserRowSubTable extends Component {
    state = {
        filterid: 0,
        pageloading: true,
        data: []
    };

    componentWillMount() {
        this.state.filterid = this.props.filterid;
        this.performSearch();
    }

    performSearch() {
        Admin.managerStructure(this.state.filterid)
            .then(response => this.setState({pageloading: false, data: response}))
            .catch(e => this.setState({pageloading: false}));
    }

    render({player, level = 1, onClick, isWidget = false}) {
        return !!this.state.pageloading?
            <div class="text-center text-base text-gray-500">
                <Trans>Attendi... <i class="fa fa-spin fa-gear" /></Trans>
            </div>
            : (this.state.data.length === 0?
                <div class="text-center text-base text-gray-500">
                    <Trans>Non ci sono record da mostrare</Trans>
                </div>
                : <div class="p-1 py-3">
                    <Table>
                        <TableHead />
                        {this.state.data.map((player, idx) => [
                            <UserRow player={player} key={2*idx} onNameClick={player => {player.expanded = !player.expanded; this.setState({});}} level={level} isOdd={idx%2} isWidget={false} />,
                            !player.expanded ? null : <Cell first={true} borderColor={level == 1 ? null : COLORS[level - 2]} colspan={11} class="pl-2">
                                <UserRowSubTable key={2*idx+1} filterid={player.idstruttura} level={level + 1} />
                            </Cell>
                        ])}
                    </Table>
                </div>);
    }
}

const TableHead = () => <HRow>
    <HCell first={true} class="w-32"><Trans>User ID</Trans><br /><Trans>Date</Trans></HCell>
    <HCell class=" border-l"><Trans>Login</Trans><br /><Trans>Email</Trans></HCell>
    <HCell class="w-32 border-l"><Trans>Level</Trans></HCell>
    <HCell class="w-48 border-l"><Trans>Site</Trans><br /><Trans>Network</Trans></HCell>
    <HCell action={true} class="w-32 border-l"><Trans>Total Usable</Trans></HCell>
    <HCell action={true} class="w-32 border-l"><Trans>Fido</Trans></HCell>
    <HCell action={true} class="w-32 border-l"><Trans>Saldo</Trans></HCell>
    <HCell action={true} class="w-48 border-l"><Trans>Actions</Trans></HCell>
</HRow>;

const Popup = (url) => window.open(
    url,
    '_blank',
    'width=800,height=600,scrollbars=yes'
);

const UserRow = ({player, empty = '—', onNameClick = null, level = 1, isOdd, isWidget}) => <Row class={isOdd ? '' : "bg-gray-100"}>
    <Cell class="p-1" first={true} borderColor={level == 1 ? null : COLORS[level - 2]}>
        <span class="block text-blue-500"><Trans>ID: <strong>{player.idcredenziale || player.idstruttura}</strong></Trans></span>
        <span class="block">{!!player.created? player.created : '-'}</span>
    </Cell>
    <Cell class="p-1 border-l">
        <span class="block text-green-500 cursor-pointer whitespace-pre" onClick={e => onNameClick && player.type != 'player' && onNameClick(player)}>
            {player.type != 'player'
                ? <PlusIcon class="inline relative h-3 mr-1 -top-px" style={"color:"+COLORS[level - 2]} />
                : <UserIcon class="inline relative h-3 mr-1 -top-px" style={"color:"+COLORS[level - 2]} />}
            {player.company}
        </span>
    </Cell>
    <Cell class="p-1 border-l text-center">
        <span class="block">#{level}</span>
    </Cell>
    <Cell class="p-1 border-l text-center">
        <span class="block">{player.skin}</span>
        {player.skin != player.network && <span class="block">{player.network}</span>}
    </Cell>
    <Cell class="p-1 border-l text-right">
        {player.account.map(wallet => <MoneyFormatter currency={wallet.currency} value={wallet.balance} />)}
    </Cell>
    <Cell class="p-1 border-l text-right">
        {player.account.map(wallet => <MoneyFormatter currency={wallet.currency} value={wallet.fido} />)}
    </Cell>
    <Cell class="p-1 border-l text-right">
        {player.account.map(wallet => <MoneyFormatter currency={wallet.currency} value={wallet.balance - wallet.fido} />)}
    </Cell>
    <Cell action={true} class="p-1 border-l">
        {player.type != 'player' && false? <ActionButton
            label="U"
            class="px-4 mr-1 font-bold inline"
            onClick={e => e.preventDefault()}
        >
            <NewUserIcon class="w-4 relative inline-block top-[-2px] left-[2px]" />
        </ActionButton> : null}
        <ActionButton
            label="E"
            class="px-4 mr-1 font-bold inline"
            color="green"
            onClick={e => openTopupPopup(mapToStandard(player))}
        >
            <TransactionIcon class="w-5 relative inline-block top-[-3px]" />
        </ActionButton>
        {player.type != 'player' ? <ActionButton
            label="E"
            class="px-4 mr-1 font-bold inline"
            color="orange"
            onClick={e => ManagerTransactionPopup(player.company)}
        >
            <TransactionsListIcon class="w-5 relative inline-block h-5 top-[-3px]" />
        </ActionButton> : <ActionButton
            label="E"
            class="px-4 mr-1 font-bold inline"
            color="orange"
            onClick={e => UserTransactionPopup(player.company)}
        >
            <TransactionsListIcon class="w-5 relative inline-block h-5 top-[-3px]" />
        </ActionButton>}
    </Cell>
</Row>;

function mapToStandard(player) {
    return {
        id: player.idcredenziale || player.idstruttura,
        affiliate: player.type != 'player',
        shop: !!player.shop,
        parent: player.idparent
    }
}

const NewUserIcon = (props) =>
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class={props.class} style={(props.color ? 'color:'+props.color+';' : '')+props.style}>
        <path fill="currentColor" d="M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" /></svg>;

const TransactionIcon = (props) =>
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="money-check-edit-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class={props.class} style={(props.color ? 'color:'+props.color+';' : '')+props.style}>
        <path fill="currentColor" d="M204.78 116.47l4.1 4.1 71.69-71.8L238.78 7a24.1 24.1 0 0 0-33.9 0L167 44.87a24 24 0 0 0 0 33.8zM608 160H437l120.25 120.28A64 64 0 0 1 576 325.54V400a16 16 0 0 1-16 16H264a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h163l-64-64h-99a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h67L203 160H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM144 415.88V432a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8v-16.29a57.26 57.26 0 0 1-31.37-11.35 8 8 0 0 1-.57-12.14L91.81 381a8.21 8.21 0 0 1 10.13-.73 24.08 24.08 0 0 0 12.82 3.73h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V240a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16.29a57.18 57.18 0 0 1 31.37 11.35 8 8 0 0 1 .57 12.14L164.18 291a8.22 8.22 0 0 1-10.14.73 23.93 23.93 0 0 0-12.81-3.73h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.57 23.42 31.57 43.39 0 24.53-19.04 44.44-42.66 45.07zm318.87-41.25a32 32 0 0 0 22.62 9.37H528a16 16 0 0 0 16-16v-42.46a32 32 0 0 0-9.37-22.63L303.17 71.47l-71.7 71.7z" class=""></path>
    </svg>;

const UserIcon = (props) =>
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class={props.class} style={(props.color ? 'color:'+props.color+';' : '')+props.style}>
        <path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" class=""></path></svg>;

const PlusIcon = (props) =>
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class={props.class} style={(props.color ? 'color:'+props.color+';' : '')+props.style}>
        <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" class=""></path></svg>;

const TransactionsListIcon = (props) =>
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="clipboard-list" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class={props.class} style={(props.color ? 'color:'+props.color+';' : '')+props.style}>
        <path fill="currentColor" d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z" class=""></path></svg>
